<div class="actions">
	<div class="close-button">
		<button mat-raised-button dodo-raised-button (click)="closeDialog()">
			Close
		</button>
		<!-- <dodo-icon-raised-button
			[iconImage]="'/assets/img/icons/icon-cancel-purple.svg'"
			[radius]="0"
			(clicked)="closeDialog()"
		>
			Close
		</dodo-icon-raised-button> -->
	</div>
</div>
<iframe
	_ngcontent-c45=""
	[src]="callbackFormUrl"
	id="request-callback-iframe"
	allowtransparency="true"
	scrolling="no"
	width="320px"
	height="480px"
	frameborder="0"
	style="border:none; text-align:center;"
>
</iframe>
